import { Token } from 'config/types'
import { useMobileBalanceSelect } from 'layout/Components/BalanceSelect/hooks'
import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ModalBody, ModalFooter, ModalHeader } from 'UIKit/AlchemyModal'
import Button from 'UIKit/Button'
import { ModalProps } from 'UIKit/Modal'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { CurrencyDisplayInfo } from '../SelectedCurrencyItem'
import {
  PAYMENT_MODAL_THEME,
  PaymentChevronRightIcon,
  PaymentInputContainer,
  PaymentLabel,
  StickyButtonWrapper,
  StyledActionButton,
  StylePaymentModal,
} from '../styles'
import { SelectedDateItem } from './FilterDateModal'
import { SelectedStatusItem } from './FilterStatusModal'
import { IControllPaymentFilter, IPaymentTransactionFilter, useTransactionFilter } from './hooks'

const SelectedTokenItem: React.FC<{
  token: Token
  onSelect: (token: Token) => void
}> = ({ token, onSelect }) => {
  const { handlePresentMobileBalanceSelect } = useMobileBalanceSelect()
  return (
    <PaymentInputContainer
      justifyContent="space-between"
      p="12px"
      onClick={() =>
        handlePresentMobileBalanceSelect({
          handleSelectBalance: ({ token }) => onSelect(token),
          selectedToken: token,
          enableSearch: true,
          enableSetting: false,
        })
      }
    >
      <PaymentLabel color="var(--pm-text-trigger-color)">
        <Trans>Currency</Trans>
      </PaymentLabel>
      <RowMiddle gap="8px">
        {token ? (
          <RowMiddle flex={1} gap="4px">
            <TokenLogo token={token} size={20} />
            <CurrencyDisplayInfo token={token} hideNetwork />
          </RowMiddle>
        ) : (
          <RowMiddle flex={1} gap="8px">
            <Text small color="var(--pm-label-color)">
              <Trans>All Token</Trans>
            </Text>
          </RowMiddle>
        )}

        <RowMiddle width={12}>
          <PaymentChevronRightIcon />
        </RowMiddle>
      </RowMiddle>
    </PaymentInputContainer>
  )
}
const PaymentHistoryFilterModal: React.FC<
  ModalProps<{
    control: IControllPaymentFilter<IPaymentTransactionFilter>
  }>
> = ({ data: { control: controlProps }, onDismiss }) => {
  const { t } = useTranslation()
  const control = useTransactionFilter<IPaymentTransactionFilter>({
    initialData: controlProps.filters,
    onSubmit: controlProps.onSubmit,
  })

  const handleApply = () => {
    control.submit()
    onDismiss()
  }

  return (
    <StylePaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onDismiss}>
      <ModalHeader colorTheme={PAYMENT_MODAL_THEME} title={t('Filter')} />
      <ModalBody gap="var(--pm-space-component, 20px)">
        <SelectedDateItem
          fromDate={control.filters.fromDate}
          toDate={control.filters.toDate}
          onSelect={(fromDate, toDate) => {
            control.onChange('fromDate', fromDate)
            control.onChange('toDate', toDate)
          }}
        />
        <SelectedTokenItem token={control.filters.currency} onSelect={(token) => control.onChange('currency', token)} />
        <SelectedStatusItem status={control.filters.status} onSelect={(status) => control.onChange('status', status)} />
      </ModalBody>
      <ModalFooter>
        <StickyButtonWrapper>
          <StyledActionButton disabled={control.isInvalid} onClick={handleApply}>
            <Trans>Apply</Trans>
          </StyledActionButton>

          <Button variant="text" onClick={control.reset}>
            <Text fontWeight={500} small bold color="strokeAlt3">
              <Trans>Clear Filter</Trans>
            </Text>
          </Button>
        </StickyButtonWrapper>
      </ModalFooter>
    </StylePaymentModal>
  )
}

export default PaymentHistoryFilterModal
